import React from 'react';
import PropTypes from 'prop-types';

import { AButton } from '../../atoms';
import { MImagePreview } from '../../molecules';
import uploadImage from '../../../helpers/uploadImage';

export default class OImagePreview extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			imageUploading: false,
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleClick = this.handleClick.bind(this);
		this.handleRemove = this.handleRemove.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
		this.handleImageUpload = this.handleImageUpload.bind(this);
	}

	handleClick() {
		this.uploadFile();
	}

	handleImageUpload(event) {
		const file = event.target.files;

		if (this.props.onUpload) {
			this.setState({ imageUploading: true });
			uploadImage(file[0])
				.then((res) => {
					this.props.onUpload({
						imageFile: file[0],
						url: res.data.url,
						uuid: res.data.uuid,
					});
					this.setState({ imageUploading: false });
				})
				.catch(() => {
					this.setState({ imageUploading: false });
				});
		}
	}

	uploadFile() { // eslint-disable-line
		const input = document.createElement('input');
		input.type = 'file';
		input.click();
		input.onchange = this.handleImageUpload;
	}

	handleRemove(item) {
		if (this.props.onRemove) {
			this.props.onRemove(item);
		}
	}

	render() {
		return (
			<section className="o-section-extra-images">
				<h2>Extra images</h2>
				<MImagePreview items={this.props.items} isUploading={this.state.imageUploading} onClick={this.handleRemove} />
				<AButton value="Kies afbeeldingen" onClick={this.handleClick} />
			</section>
		);
	}
}

MImagePreview.propTypes = {
	items: PropTypes.array,
	onUpload: PropTypes.func,
	onRemove: PropTypes.func,
};

MImagePreview.defaultProps = {
	items: [],
	onUpload: undefined,
	onRemove: undefined,
};



// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.image-preview.js